var url = window.location.origin + "/images/"
 
 export const IMAGE = {
    loader: url + 'loader-icon.png',
    wallet: url + 'Icon-2.png',
    user: url + 'Icon-1.png',
    location: url + 'Icon.png',
}